/**
 * 路由配置项
 * @param path: 路径
 * @param redirect: 重定向
 * @param component: 组件路由
 * @param name: 说明
 * @param meta: router参数
 *        title: 页面标题
 */

// 通用路由 不需要走权限，不需要走登录
export const constantRoutesConfig = [{
    path: '/',
    component: 'layout/base/home-container',
    redirect: '/',
    children: [{
            path: '/',
            name: 'home',
            meta: {
                title: '首页'
            },
            component: 'views/home/index.vue',
        },
        {
            path: '/handle',
            name: 'handle',
            meta: {
                title: '首页'
            },
            component: 'views/handle/index.vue',
        },
        {
            path: '/maintain',
            name: 'maintain',
            meta: {
                title: '维护'
            },
            component: 'views/maintain/index.vue',
        },
    ]
}, ]

// 有关权限路由  需要走权限，需要走登录
export const asyncRoutesConfig = []


// WEBPACK FOOTER //
// ./src/router/config.js